import React from "react"
import TShirtSell from "../components/TShirtSell";

function TShirt() {
  return (
    <div>
      <TShirtSell />
    </div>
  )
};

export default TShirt;
